import { useEffect } from 'react';

const SITE_URL = 'https://nicocarr.ca';

// Met à jour une balise déjà présente dans public/index.html (sans créer de doublon)
function setAttr(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

// Titre, description et lien canonique pour le référencement de chaque page
function Seo({ title, description, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Nicolas Carriere` : 'Nicolas Carriere | Bilingual Computer Programmer';
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setAttr('meta[name="description"]', 'content', description);
    setAttr('link[rel="canonical"]', 'href', url);
    setAttr('meta[property="og:title"]', 'content', fullTitle);
    setAttr('meta[property="og:description"]', 'content', description);
    setAttr('meta[property="og:url"]', 'content', url);
    setAttr('meta[name="twitter:title"]', 'content', fullTitle);
    setAttr('meta[name="twitter:description"]', 'content', description);
  }, [title, description, path]);

  return null;
}

export default Seo;
